import {
  ADMIN_LOGIN,
  UPDATE_LANGUAGE,
  ADMIN_LOGOUT,
  ADMIN_VERIFY,
  FORGOT_PASSWORD,
  RESET_PASSWORD
} from '@/api'

export default {
  adminLogin({commit, dispatch}, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (response.data.data) {
        commit('getLoginData', response.data.data)
        dispatch('verify', response.data.data.token)
      }

      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    ADMIN_LOGIN(payload, successCallback, errorCallback)
  },

  verify ({ commit, state }, payload) {
    let errorCallback = () => {
      commit('endVerify')

      if (typeof payload.errorCallback === 'function') {
        payload.errorCallback()
      }
    }

    let successCallback = (response) => {
      commit('verifySuccess', response.data.data)

      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    commit('startVerify')

    ADMIN_VERIFY(successCallback, errorCallback)
  },

  adminLogout({commit}, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = () => {
      commit('logout')

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }

    ADMIN_LOGOUT(successCallback, errorCallback)
  },

  updateLanguage({ commit }, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = () => {
      commit('updateLanguage', { lang: payload.lang })

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }

    UPDATE_LANGUAGE(payload, successCallback, errorCallback)
  },

  forgotPassword(state, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = () => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }

    FORGOT_PASSWORD(payload, successCallback, errorCallback)
  },

  resetPassword(state, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = () => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }

    RESET_PASSWORD(payload, successCallback, errorCallback)
  }

};
